module.exports = __webpack_public_path__ + "static/media/visa_color.a50a103f.png";